import type { ScreenSchema } from './types';
const chatSchema: ScreenSchema = {
  template: 'chat',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    },
    // messages iterated slot — transcript-only (deferred to Phase 9)
    message: {
      use: 'transcript',
      iterate: 'messages',
      keyPrefix: 'message',
      parts: [{ field: 'you' }, { field: 'them' }]
    },
    feedback: { parts: [{ field: 'feedback' }] }
  }
};
export default chatSchema;
